const valueParser = require('postcss-value-parser');

const NUMBER_RE = /^[+-]?(?:(?:\d+\.?\d*)|(?:\.\d+))(?:e[+-]?\d+)?$/i;
const DP_RE = /^([+-]?(?:(?:\d+\.?\d*)|(?:\.\d+))(?:e[+-]?\d+)?)dp$/i;

const TRANSFORM_PROPERTIES = new Set([
  'transform',
  '-webkit-transform',
  '-moz-transform',
  '-ms-transform',
  '-o-transform',
  'WebkitTransform',
  'webkitTransform',
  'MozTransform',
  'mozTransform',
  'msTransform',
  'MsTransform',
  'OTransform',
  'oTransform',
]);

const LENGTH_FUNCTION_ARGUMENTS = new Map([
  ['translate', [1, 2]],
  ['translatex', [1, 1]],
  ['translatey', [1, 1]],
  ['translatez', [1, 1]],
  ['translate3d', [3, 3]],
  ['perspective', [1, 1]],
]);

const ANGLE_FUNCTION_ARGUMENTS = new Map([
  ['rotate', [1, 1]],
  ['rotatex', [1, 1]],
  ['rotatey', [1, 1]],
  ['rotatez', [1, 1]],
  ['skew', [1, 2]],
  ['skewx', [1, 1]],
  ['skewy', [1, 1]],
]);

function isTransformProperty(prop) {
  return TRANSFORM_PROPERTIES.has(String(prop));
}

function isBalanced(value) {
  let depth = 0;
  let quote = '';

  for (let index = 0; index < value.length; index += 1) {
    const char = value[index];

    if (quote) {
      if (char === '\\') index += 1;
      else if (char === quote) quote = '';
    } else if (char === '"' || char === '\'') {
      quote = char;
    } else if (char === '(') {
      depth += 1;
    } else if (char === ')') {
      depth -= 1;
      if (depth < 0) return false;
    }
  }

  return depth === 0 && !quote;
}

function hasUnclosed(nodes) {
  return nodes.some((node) => (
    node.unclosed || (Array.isArray(node.nodes) && hasUnclosed(node.nodes))
  ));
}

function normalizeLength(value) {
  const dpMatch = value.match(DP_RE);
  if (dpMatch) return `${dpMatch[1]}px`;

  return NUMBER_RE.test(value) && Number(value) !== 0
    ? `${value}px`
    : value;
}

function normalizeAngle(value) {
  return NUMBER_RE.test(value) && Number(value) !== 0
    ? `${value}deg`
    : value;
}

function getDirectArguments(node) {
  return node.nodes.filter((child) => (
    child.type === 'word'
    || child.type === 'function'
    || child.type === 'string'
  ));
}

function normalizeArguments(node, range, normalizer) {
  const args = getDirectArguments(node);
  const [min, max] = range;

  if (args.length < min || args.length > max) return;

  args.forEach((arg) => {
    if (arg.type === 'word') arg.value = normalizer(arg.value);
  });
}

function normalizeTransformFunction(node) {
  const name = node.value.toLowerCase();
  const lengthRange = LENGTH_FUNCTION_ARGUMENTS.get(name);
  const angleRange = ANGLE_FUNCTION_ARGUMENTS.get(name);

  if (lengthRange) {
    normalizeArguments(node, lengthRange, normalizeLength);
    return;
  }

  if (angleRange) {
    normalizeArguments(node, angleRange, normalizeAngle);
    return;
  }

  if (name === 'rotate3d') {
    const args = getDirectArguments(node);
    if (args.length === 4 && args[3].type === 'word') {
      args[3].value = normalizeAngle(args[3].value);
    }
  }
}

function normalizeTransformValue(value) {
  const source = String(value);

  if (!isBalanced(source)) return source;

  try {
    const parsed = valueParser(source);

    if (hasUnclosed(parsed.nodes)) return source;

    // 只处理 transform 顶层函数，嵌套的 calc()/var() 等表达式保持原样。
    parsed.nodes.forEach((node) => {
      if (node.type === 'function') normalizeTransformFunction(node);
    });

    return parsed.toString();
  } catch (_) {
    return source;
  }
}

module.exports = {
  isTransformProperty,
  normalizeTransformValue,
};
